// Phone operators come from the admin platform (via /api/phone-operators). Only brand colours live here.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const BRAND = {
  etisalat: { accent: '#E4002B', tint: 'rgba(228,0,43,0.10)' },
  du: { accent: '#00A9CE', tint: 'rgba(0,169,206,0.10)' },
  virgin: { accent: '#E10A0A', tint: 'rgba(225,10,10,0.10)' },
};
const NEUTRAL = { accent: '#1E9BD9', tint: 'rgba(30,155,217,0.10)' };

export const operatorSlug = (name) => ((name || '').toLowerCase().trim().match(/^[a-z0-9]+/) || [''])[0];

// `logo` from the API is a relative path (null when the admin has no logo for that operator)
export const operatorLogo = (op) => (op?.logo ? `${BACKEND_URL}${op.logo}` : null);

export const operatorBrand = (slug) => BRAND[slug] || NEUTRAL;

// Saved snapshot on the item wins for names; the admin list supplies the logo and fills names for older items.
export const operatorView = (item, operators = []) => {
  const d = item?.details || {};
  const id = item?.operator_id || d.operator_id;
  const ownSlug = operatorSlug(item?.operator || d.operator || item?.operator_name_en || d.operator_name_en);
  const listed = operators.find((o) => (id ? o.id === id : ownSlug && o.slug === ownSlug));
  const slug = ownSlug || listed?.slug || '';
  const nameEn = item?.operator_name_en || d.operator_name_en || listed?.name_en || slug;
  const nameAr = item?.operator_name_ar || d.operator_name_ar || listed?.name_ar || nameEn;
  return { id: id || listed?.id || null, slug, nameAr, nameEn, logo: operatorLogo(listed), ...operatorBrand(slug) };
};
